import * as r from "react";
import n from "../lib/IconBase.es.js";
import i from "../defs/Fingerprint.es.js";
const e = r.forwardRef((o, t) => /* @__PURE__ */ r.createElement(n, { ref: t, ...o, weights: i }));
e.displayName = "FingerprintIcon";
const p = e;
export {
  p as Fingerprint,
  e as FingerprintIcon
};
